import { I18nComponente } from "@/types/gerais"

export const ABotaoDeAcaoi18n: I18nComponente = {
  "pt-BR": {
    iniciarAtividade: "iniciar atividade",
    finalizarAtividade: "finalizar atividade"
  },
  "es-CO": {
    iniciarAtividade: "iniciar actividad",
    finalizarAtividade: "finalizar actividad"
  }
}
